import _styled from "styled-components";
import React from 'react';
import * as styles from "./ContentOverlay.styles";
import { useSiteChromeDynamicContext } from "../../../context/SiteChromeDynamicContext/useSiteChromeDynamicContext";
export var ContentOverlay = function ContentOverlay() {
  var _useSiteChromeDynamic = useSiteChromeDynamicContext(),
    _useSiteChromeDynamic2 = _useSiteChromeDynamic.contentOverlay,
    isDisplayed = _useSiteChromeDynamic2.isDisplayed,
    top = _useSiteChromeDynamic2.top;
  return isDisplayed ? /*#__PURE__*/React.createElement(_StyledDiv, {
    "data-testid": "content-overlay",
    style: {
      '--overlayTop': top
    },
    $_css: styles.overlay
  }) : null;
};
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "ContentOverlay___StyledDiv",
  componentId: "sc-1ey4gmd-0"
})(["", ""], function (p) {
  return p.$_css;
});